import IconCopy from '@apollo/icons/default/IconCopy.svg';
import { Button, Code } from '@apollo/orbit';
import copy from 'copy-to-clipboard';
import React, { useCallback } from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export const SchemaHash = ({ hash }: { hash: string }) => {
  const handleCopyClick = useCallback(() => {
    copy(hash);
  }, [hash]);
  return (
    <Tooltip
      placement="top"
      interactive
      label={
        <div>
          <span className="break-words">{hash}</span>
          <Button
            variant="hidden"
            size="xs"
            leftIcon={<IconCopy />}
            onClick={handleCopyClick}
            className="mt-2"
          >
            Copy
          </Button>
        </div>
      }
    >
      <Code>{hash.slice(0, 12)}</Code>
    </Tooltip>
  );
};
